export default __webpack_public_path__ + "static/media/inpact_investment-dk.7bd45efa.svg";